// extracted by mini-css-extract-plugin
export var speaker = "style-module--speaker--6ab7e";
export var wrap = "style-module--wrap--48ae7";